import instance from "./instance";

const parseDate = (date: string) => date.split("/").reverse().join("-");

async function findPersonByDocument(document: string) {
  try {
    const response = await instance.get(
      `/people/${document.replace(/\D/g, "")}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function findCompanyByDocument(document: string) {
  try {
    const response = await instance.get(
      `/companies/${document.replace(/\D/g, "")}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function create(payload: any) {
  const parsed = {
    ...payload,
    partner: {
      ...payload.partner,
      ...(payload.partner.birthdate && {
        birthdate: parseDate(payload.partner.birthdate),
      }),
      ...(payload.partner.foundation_date && {
        foundation_date: parseDate(payload.partner.foundation_date),
      }),
    },
  };

  try {
    const response = await instance.post("/", parsed);
    return response.data;
  } catch (error) {
    throw error;
  }
}

function refreshRecaptchaToken(token: string) {
  instance.defaults.headers["x-recaptcha-token"] = token;
}

export default {
  findPersonByDocument,
  findCompanyByDocument,
  refreshRecaptchaToken,
  create,
};
